import script from "./CustomerDashboardFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDashboardFooter.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDashboardFooter.vue?vue&type=style&index=0&id=14dc2279&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14dc2279"]])

export default __exports__